import {
  HUMANITARIAN_CASES_LIST_LOADING,
  HUMANITARIAN_CASES_LIST_SUCCESS,
  HUMANITARIAN_CASES_LIST_FAILURE,
} from "redux/types";

const initialState = {
  humanitarainCasesLoading: false,
  humanitarainCases: null,
  errors: null,
};

export const humanitarainCasesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case HUMANITARIAN_CASES_LIST_LOADING:
      return { ...state, humanitarainCasesLoading: action.payload };
    case HUMANITARIAN_CASES_LIST_SUCCESS:
      return { ...state, humanitarainCases: action.payload };
    case HUMANITARIAN_CASES_LIST_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
